// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__d8Pj8","active":"Header_active__mCgd-","nav":"Header_nav__iCcUP","logo":"Header_logo__AUtIw","hamburger":"Header_hamburger__Piwnt"};